import * as types from '../constants/actions';
import { ReservationDefaults } from '../props';
import {
  asyncDefaults,
  makeAsyncReducer,
  makeAsyncResetReducer,
  mergeReducers
} from '../../../ui-lottery/src/utils/async_utils';

const fetchReservation = makeAsyncReducer(types.FETCH_RESERVATION);
const createReservation = makeAsyncReducer(types.CREATE_RESERVATION);
const updateReservation = makeAsyncReducer(types.UPDATE_RESERVATION);
const resetReservation = makeAsyncResetReducer(types.RESET_RESERVATION, ReservationDefaults);

const reservation = mergeReducers(asyncDefaults(ReservationDefaults), types.PP_PREFIX,
  fetchReservation,
  createReservation,
  updateReservation,
  resetReservation
);

export default reservation;

export const selectors = {
  getReservation: (state) => state.parkpass.reservation.data
};
